var map = {
	"./Australia.png": "685b",
	"./Austria.png": "a2b0",
	"./Belgium.png": "f107",
	"./Blank.png": "0357",
	"./Brasil.png": "5ded",
	"./Canada.png": "3880",
	"./Chile.png": "e5e4",
	"./Colombia.png": "d15e",
	"./Denmark.png": "d4e6",
	"./Finland.png": "5b4a",
	"./France.png": "78e4",
	"./Germany.png": "2672",
	"./Ghana.png": "e99c",
	"./Greece.png": "93c6",
	"./India.png": "0bec",
	"./Ireland.png": "4d5a",
	"./Italy.png": "114d",
	"./Japan.png": "af9d",
	"./Latvia.png": "cb71",
	"./Lithuania.png": "b0b9",
	"./Malta.png": "6aca",
	"./Mauritius.png": "6bb8",
	"./New Zealand.png": "b91e",
	"./Norway.png": "65d2",
	"./Poland.png": "cab4",
	"./Russia.png": "5e13",
	"./Singapore.png": "aa82",
	"./Slovakia.png": "8a58",
	"./South Africa.png": "a64c",
	"./Spain.png": "c01b",
	"./Sweden.png": "9397",
	"./Switzerland.png": "740d",
	"./Turkey.png": "7c8e",
	"./UK.png": "f389",
	"./USA.png": "6b18",
	"./Uruguay.png": "f46d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";